// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12kvJ","full-width":"styles_full-width__2dvXb","fullWidth":"styles_full-width__2dvXb"};